'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-zinc-950/95 backdrop-blur-md border-b border-zinc-800' : 'bg-transparent'
      }`}
    >
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AppLogo size={32} />
          <span className="font-bold text-lg tracking-tight text-zinc-100">
            HireTruckers<span className="text-amber-400">365</span>
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8">
          <a href="#how-it-works" className="text-sm text-zinc-400 hover:text-zinc-100 transition-colors">
            How It Works
          </a>
          <a href="#features" className="text-sm text-zinc-400 hover:text-zinc-100 transition-colors">
            Features
          </a>
          <a href="#testimonials" className="text-sm text-zinc-400 hover:text-zinc-100 transition-colors">
            Success Stories
          </a>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link href="/sign-up-login-screen" className="btn-secondary text-xs px-4 py-2">
            Sign In
          </Link>
          <Link href="/sign-up-login-screen" className="btn-primary text-xs px-4 py-2">
            Get Started Free
          </Link>
        </div>

        <button
          className="md:hidden p-2 text-zinc-400 hover:text-zinc-100 transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle mobile menu"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-zinc-950 border-b border-zinc-800 px-6 pb-4 animate-fade-in">
          <div className="flex flex-col gap-4 pt-4">
            <a href="#how-it-works" className="text-sm text-zinc-400" onClick={() => setMobileOpen(false)}>
              How It Works
            </a>
            <a href="#features" className="text-sm text-zinc-400" onClick={() => setMobileOpen(false)}>
              Features
            </a>
            <div className="flex gap-3 pt-2">
              <Link href="/sign-up-login-screen" className="btn-secondary text-xs flex-1 text-center">
                Sign In
              </Link>
              <Link href="/sign-up-login-screen" className="btn-primary text-xs flex-1 text-center">
                Get Started
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}